(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["avontic-business-text-support"] && !Shopify.designMode) return;
  try {
    const avbCopyFallback = (value) => {
    const input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-avb-copy-number]');
    if (!button) return;
    const value = button.dataset.copyValue;
    const status = button.parentElement.querySelector('[data-avb-copy-status]');
    const label = button.querySelector('[data-avb-copy-label]');
    const defaultLabel = label.textContent;
    const showSuccess = () => {
      const success = button.dataset.copySuccess;
      status.textContent = success;
      label.textContent = success;
      window.setTimeout(() => {
        label.textContent = defaultLabel;
      }, 2200);
    };
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
      } else {
        avbCopyFallback(value);
      }
      showSuccess();
    } catch (error) {
      try {
        avbCopyFallback(value);
        showSuccess();
      } catch (fallbackError) {
        status.textContent = value;
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avontic-fit-check"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('avontic-fit-check')) {
    class AvonticFitCheck extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.config = this.readConfig();
        this.statusElement = this.querySelector('[data-av-fit-status]');
        this.titleElement = this.querySelector('[data-av-fit-title]');
        this.noteElement = this.querySelector('[data-av-fit-note]');
        this.confidenceElement = this.querySelector('[data-av-fit-confidence]');
        this.factsElement = this.querySelector('[data-av-fit-facts]');
        this.yearsElement = this.querySelector('[data-av-fit-years]');
        this.yearsValueElement = this.querySelector('[data-av-fit-years-value]');
        this.modelNumbersElement = this.querySelector('[data-av-fit-model-numbers]');
        this.modelNumbersValueElement = this.querySelector('[data-av-fit-model-numbers-value]');
        this.normalizedCompatibilityMap = this.normalizeCompatibilityMap(this.config.compatibilityMap);
        this.config.variants ||= {};
        if (this.config.selectedVariant?.id) {
          this.config.variants[String(this.config.selectedVariant.id)] = this.config.selectedVariant;
        }
        this.lastVariantId = null;
        this.requestSequence = 0;
        this.bindVariantEvents();
        this.observeVisibility();
        const requestedVariantId = new URL(window.location.href).searchParams.get('variant');
        this.updateVariant(requestedVariantId || this.config.selectedVariant?.id);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.visibilityObserver?.disconnect();
        this.requestSequence += 1;
      }

      readConfig() {
        const element = this.querySelector('[data-av-fit-config]');
        if (!element) return { variants: {}, translations: {} };
        try {
          return JSON.parse(element.textContent);
        } catch (error) {
          return { variants: {}, translations: {} };
        }
      }

      bindVariantEvents() {
        this.productForm = document.forms[this.dataset.productFormId];
        this.handleChange = (event) => {
          if (event.target?.name !== 'id') return;
          queueMicrotask(() => {
            if (!this.variantMatchesRequestedUrl(event.target.value)) {
              this.renderPending();
              return;
            }
            this.updateVariant(event.target.value);
          });
        };
        this.handleVariantEvent = (event) => {
          if (event.detail?.formId && event.detail.formId !== this.dataset.productFormId) return;
          const variant = event.detail?.variant;
          if (!this.variantMatchesRequestedUrl(variant?.id)) {
            this.renderPending();
            return;
          }
          this.updateVariant(variant?.id, variant);
        };
        this.handleProductRerender = (event) => {
          const fragment = event.detail?.htmlFragment;
          if (!fragment?.querySelector) return;
          const escapedBlockId = window.CSS?.escape ? window.CSS.escape(this.dataset.blockId) : this.dataset.blockId;
          const blockSelector = '[data-block-id="' + escapedBlockId + '"] [data-av-fit-config]';
          const configElement = fragment.querySelector(blockSelector) || fragment.querySelector('[data-av-fit-config]');
          if (!configElement) return;
          try {
            const remoteConfig = JSON.parse(configElement.textContent);
            this.config.optionFound = remoteConfig.optionFound;
            this.config.optionIndex = remoteConfig.optionIndex;
            this.config.detectionMethod = remoteConfig.detectionMethod;
            this.config.gateState = remoteConfig.gateState;
            if (remoteConfig.compatibilityMap) {
              this.config.compatibilityMap = remoteConfig.compatibilityMap;
              this.normalizedCompatibilityMap = this.normalizeCompatibilityMap(remoteConfig.compatibilityMap);
            }
            if (remoteConfig.selectedVariant?.id) {
              this.config.variants[String(remoteConfig.selectedVariant.id)] = remoteConfig.selectedVariant;
              this.lastVariantId = null;
              this.updateVariant(remoteConfig.selectedVariant.id, remoteConfig.selectedVariant);
            }
          } catch (error) {
            return;
          }
        };
        this.handlePopState = () => {
          const variantId = new URL(window.location.href).searchParams.get('variant');
          this.updateVariant(variantId || this.productForm?.elements?.id?.value);
        };
        this.productForm?.addEventListener('change', this.handleChange, { signal: this.abortController.signal });
        this.productForm?.addEventListener('product:rerender', this.handleProductRerender, { signal: this.abortController.signal });
        this.productForm?.addEventListener('variant:change', this.handleVariantEvent, { signal: this.abortController.signal });
        window.addEventListener('popstate', this.handlePopState, { signal: this.abortController.signal });
      }

      observeVisibility() {
        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }
        this.visibilityObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => this.classList.toggle('is-visible', entry.isIntersecting));
        }, { rootMargin: '100px 0px' });
        this.visibilityObserver.observe(this);
      }

      async updateVariant(variantId, eventVariant = null) {
        const id = this.normalizeVariantId(variantId);
        if (!id) {
          this.requestSequence += 1;
          this.renderPending();
          return;
        }
        if (id === this.lastVariantId) return;
        const requestId = ++this.requestSequence;
        let variant = this.config.variants?.[id] || null;
        if ((!variant || !variant.gateState) && eventVariant) {
          this.renderVariant(this.variantFromEvent(eventVariant));
        }
        if (!variant || !variant.gateState) {
          variant = await this.fetchSelectedVariant(id);
        }
        if (requestId !== this.requestSequence) return;
        if (!variant) {
          this.renderPending();
          return;
        }
        this.lastVariantId = id;
        this.renderVariant(variant);
      }

      variantFromEvent(variant) {
        const optionValue = this.config.optionFound ? variant.options?.[this.config.optionIndex] : variant.title;
        return {
          id: String(variant.id || ''),
          available: Boolean(variant.available),
          gateState: 'verification-required',
          model: optionValue || variant.title || '',
          label: null,
          modelKey: null,
          modelNumbers: null,
          years: null,
          note: null
        };
      }

      async fetchSelectedVariant(variantId) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { headers: { Accept: 'text/html' } });
          if (!response.ok) return null;
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const escapedBlockId = window.CSS?.escape ? window.CSS.escape(this.dataset.blockId) : this.dataset.blockId;
          const blockSelector = '[data-block-id="' + escapedBlockId + '"] [data-av-fit-config]';
          const configElement = parsed.querySelector(blockSelector) || parsed.querySelector('[data-av-fit-config]');
          if (!configElement) return null;
          const remoteConfig = JSON.parse(configElement.textContent);
          if (remoteConfig.compatibilityMap) {
            this.config.compatibilityMap = remoteConfig.compatibilityMap;
            this.normalizedCompatibilityMap = this.normalizeCompatibilityMap(remoteConfig.compatibilityMap);
          }
          this.config.gateState = remoteConfig.gateState;
          const requestedId = this.normalizeVariantId(variantId);
          const selectedId = this.normalizeVariantId(remoteConfig.selectedVariant?.id);
          if (!requestedId || selectedId !== requestedId) return null;
          this.config.variants[selectedId] = remoteConfig.selectedVariant;
          return remoteConfig.selectedVariant;
        } catch (error) {
          return null;
        }
      }

      resolveCompatibility(variant) {
        const map = this.config.compatibilityMap;
        if (!map || typeof map !== 'object') return {};
        const exactEntry = (variant.modelKey && map[variant.modelKey]) || map[variant.model];
        const normalizedEntry = this.normalizedCompatibilityMap.get(this.normalizeKey(variant.modelKey || '')) || this.normalizedCompatibilityMap.get(this.normalizeKey(variant.model));
        const entry = exactEntry || normalizedEntry || {};
        if (typeof entry === 'string') return { label: entry };
        return {
          label: entry.label || entry.compatibilityLabel || entry.compatibility_label || null,
          modelNumbers: entry.modelNumbers || entry.model_numbers || null,
          years: entry.years || entry.modelYears || entry.model_years || null,
          note: entry.note || entry.compatibilityNote || entry.compatibility_note || null
        };
      }

      normalizeCompatibilityMap(map) {
        const normalized = new Map();
        if (!map || typeof map !== 'object') return normalized;
        Object.entries(map).forEach(([key, value]) => normalized.set(this.normalizeKey(key), value));
        return normalized;
      }

      normalizeKey(value) {
        return String(value || '')
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[\u2018\u2019]/g, "'")
          .toLowerCase()
          .replace(/&/g, ' and ')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim()
          .replace(/\s+/g, ' ');
      }

      normalizeVariantId(value) {
        const id = String(value || '').trim();
        return /^\d+$/.test(id) ? id : '';
      }

      variantMatchesRequestedUrl(variantId) {
        const requestedValue = new URL(window.location.href).searchParams.get('variant');
        if (requestedValue === null) return true;
        const requestedId = this.normalizeVariantId(requestedValue);
        const selectedId = this.normalizeVariantId(variantId);
        return Boolean(requestedId && selectedId && requestedId === selectedId);
      }

      formatValue(value) {
        if (Array.isArray(value)) return value.filter(Boolean).join(' · ');
        if (value && typeof value === 'object') return Object.values(value).filter(Boolean).join(' · ');
        return String(value || '').trim();
      }

      renderVariant(variant) {
        if (!variant) {
          this.renderPending();
          return;
        }
        const compatibility = this.resolveCompatibility(variant);
        const translations = this.config.translations || {};
        const gateState = variant.gateState || 'verification-required';
        const model = gateState === 'not-required' ? '' : (variant.label || compatibility.label || variant.model || translations.noData || '');
        const hasAuthoritativeData = Boolean(
          variant.label || variant.modelNumbers || variant.years || variant.note ||
          compatibility.label || compatibility.modelNumbers || compatibility.years || compatibility.note
        );
        const state = gateState === 'verified'
          ? 'confirmed'
          : gateState === 'unavailable'
            ? 'unavailable'
            : gateState === 'not-required'
              ? 'not-required'
              : 'confirm';
        const noteTemplate = state === 'confirmed' ? translations.confirmedFor : state === 'unavailable' ? translations.unavailableFor : translations.confirmFor;
        this.dataset.state = state;
        this.statusElement.textContent = state === 'confirmed' ? translations.confirmed : state === 'unavailable' ? translations.unavailable : state === 'not-required' ? translations.pending : translations.confirm;
        this.titleElement.textContent = model || translations.noData || '';
        this.noteElement.textContent = state === 'not-required' ? '' : (variant.note || compatibility.note || String(noteTemplate || '').replace('__MODEL__', model));
        this.confidenceElement.textContent = state === 'confirmed' ? translations.verified : state === 'unavailable' ? translations.notVerified : translations.review;
        this.setFact(this.yearsElement, this.yearsValueElement, variant.years || compatibility.years);
        this.setFact(this.modelNumbersElement, this.modelNumbersValueElement, variant.modelNumbers || compatibility.modelNumbers);
        this.factsElement.hidden = this.yearsElement.hidden && this.modelNumbersElement.hidden;
      }

      setFact(container, valueElement, value) {
        const formatted = this.formatValue(value);
        container.hidden = !formatted;
        valueElement.textContent = formatted;
      }

      renderPending() {
        const translations = this.config.translations || {};
        this.lastVariantId = null;
        this.dataset.state = 'pending';
        this.statusElement.textContent = translations.pending || translations.confirm || '';
        this.titleElement.textContent = translations.noData || '';
        this.noteElement.textContent = '';
        this.confidenceElement.textContent = translations.review || '';
        this.yearsElement.hidden = true;
        this.modelNumbersElement.hidden = true;
        this.factsElement.hidden = true;
      }
    }

    customElements.define('avontic-fit-check', AvonticFitCheck);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avontic-formalift-color-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('avontic-formalift-color-note')) {
    customElements.define('avontic-formalift-color-note', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.colorIndex = Number(this.dataset.colorIndex);
        this.notice = this.querySelector('.av-fl-color-note');
        this.root = this.closest('#avontic-primary-product');
        document.addEventListener('variant:change', event => {
          if (event.target instanceof Element && this.root && !this.root.contains(event.target)) return;
          const selectedColor = event.detail?.variant?.options?.[this.colorIndex];
          if (typeof selectedColor === 'string') this.notice.hidden = selectedColor !== 'Yellow and Blue';
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avontic-iphone-privacy-addon"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('avontic-iphone-privacy')) return;
    const pending = new Set();
    const uncertain = new Set();
    const allowed = new Set(['iPhone 18', 'iPhone 18 Pro', 'iPhone 18 Pro Max']);
    const jsonUrl = (url) => url.endsWith('.js') ? url : `${url}.js`;

    class AvonticIphonePrivacy extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        try { this.config = JSON.parse(this.querySelector('[data-privacy-config]').textContent); }
        catch { this.hidden = true; return; }
        this.cartIds = new Set(this.config.cartVariantIds.map(String));
        this.button = this.querySelector('[data-privacy-add]');
        this.status = this.querySelector('[data-privacy-status]');
        this.cartLink = this.querySelector('[data-privacy-cart]');
        this.button.hidden = false;
        this.select(this.config.sourceVariant);
        const options = { signal: this.controller.signal };
        this.button.addEventListener('click', () => this.add(), options);
        document.addEventListener('variant:change', (event) => {
          if (event.target === document.getElementById(this.dataset.formId)) this.select(event.detail?.variant);
        }, { ...options, capture: true });
        document.addEventListener('change', (event) => {
          const input = event.target;
          if (input.matches?.('input[data-option-position]') && input.getAttribute('form') === this.dataset.formId) {
            this.changing = true;
            this.button.disabled = true;
            this.message('');
          }
        }, { ...options, capture: true });
        document.addEventListener('cart:change', (event) => {
          if (event.detail?.cart?.items) this.setCart(event.detail.cart);
        }, options);
        document.addEventListener('avontic:privacy-state', () => this.renderState(), options);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      select(source) {
        this.changing = false;
        const device = source?.options?.[Number(this.dataset.deviceIndex)];
        this.variant = source?.id && allowed.has(device)
          ? this.config.variants.find((variant) => variant.device === device)
          : null;
        this.hidden = !this.variant;
        this.message('');
        if (!this.variant) return;
        this.querySelector('[data-privacy-match]').textContent = this.dataset.matchLabel.replace('[device]', device);
        this.querySelector('[data-privacy-price]').innerHTML = this.variant.price;
        const url = new URL(this.dataset.productUrl, location.origin);
        url.searchParams.set('variant', this.variant.id);
        this.querySelectorAll('[data-privacy-link]').forEach((link) => { link.href = url.href; });
        this.renderState();
      }

      message(text, error = false) {
        this.status.textContent = text;
        this.status.dataset.error = String(error);
      }

      setCart(cart) {
        this.cartIds = new Set(cart.items.map((item) => String(item.variant_id)));
        this.renderState();
      }

      renderState() {
        if (!this.variant) return;
        const id = String(this.variant.id);
        const inCart = this.cartIds.has(id);
        const busy = pending.has(id);
        this.button.disabled = this.changing || busy || inCart || uncertain.has(id) || !this.variant.available;
        this.button.setAttribute('aria-busy', String(busy));
        this.button.textContent = busy ? this.dataset.addingLabel : inCart ? this.dataset.addedLabel : !this.variant.available ? this.dataset.soldOutLabel : this.dataset.addLabel;
        this.cartLink.hidden = !inCart && !uncertain.has(id);
      }

      async readCart() {
        const response = await fetch(jsonUrl(this.dataset.cartUrl), { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error(this.dataset.errorLabel);
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error(this.dataset.errorLabel);
        this.setCart(cart);
        return cart;
      }

      async notifyCart(payload, cart, sectionIds) {
        cart.sections = payload.sections || {};
        if (sectionIds.some((id) => typeof cart.sections[id] !== 'string')) {
          const url = new URL(location.href);
          url.searchParams.set('sections', sectionIds.join(','));
          const response = await fetch(url, { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(15000) });
          if (response.ok) cart.sections = await response.json();
        }
        if (sectionIds.every((id) => typeof cart.sections[id] === 'string')) {
          this.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: payload.items || [], cart, onSuccessDo: 'force_open_drawer' } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart } }));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      }

      async add() {
        if (!this.variant || this.button.disabled || this.changing) return;
        const variant = this.variant;
        const id = String(variant.id);
        if (pending.has(id) || uncertain.has(id)) return;
        pending.add(id);
        document.dispatchEvent(new CustomEvent('avontic:privacy-state'));
        this.message(this.dataset.addingLabel);
        let submitted = false;
        let confirmed = false;
        try {
          const before = await this.readCart();
          if (before.items.some((item) => String(item.variant_id) === id)) {
            this.message(this.dataset.addedLabel);
            return;
          }
          if (this.changing || this.variant?.id !== variant.id) { this.message(''); return; }
          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
          const sectionIds = [...new Set(sections)].slice(0, 5);
          submitted = true;
          const response = await fetch(jsonUrl(this.dataset.addUrl), {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }], sections: sectionIds, sections_url: `${location.pathname}${location.search}` }),
            signal: AbortSignal.timeout(20000)
          });
          const payload = await response.json();
          if (!response.ok) {
            submitted = false;
            throw new Error(payload.description || payload.message || this.dataset.errorLabel);
          }
          confirmed = true;
          this.cartIds.add(id);
          this.message(this.dataset.successLabel.replace('[device]', variant.device));
          const cart = await this.readCart();
          await this.notifyCart(payload, cart, sectionIds);
        } catch (error) {
          if (submitted) {
            try {
              const cart = await this.readCart();
              confirmed = confirmed || cart.items.some((item) => String(item.variant_id) === id);
            } catch { uncertain.add(id); }
            if (confirmed) {
              this.cartIds.add(id);
              this.message(this.dataset.successLabel.replace('[device]', variant.device));
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            } else {
              uncertain.add(id);
              this.message(this.dataset.uncertainLabel, true);
            }
          } else {
            this.message(error?.name === 'TimeoutError' ? this.dataset.errorLabel : error.message || this.dataset.errorLabel, true);
          }
        } finally {
          pending.delete(id);
          document.dispatchEvent(new CustomEvent('avontic:privacy-state'));
        }
      }
    }

    customElements.define('avontic-iphone-privacy', AvonticIphonePrivacy);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avontic-premium-experience"] && !Shopify.designMode) return;
  try {
    (() => {
 document.addEventListener('click',event=>{
  const link=event.target.closest?.('a[href]');
  if(!link)return;
  const url=new URL(link.href,location.href);
  if(url.origin!==location.origin||url.pathname!==location.pathname||!url.hash)return;
  let target;
  try{target=document.getElementById(decodeURIComponent(url.hash.slice(1)));}catch{return;}
  for(let node=target;node;node=node.parentElement){if(node.tagName==='DETAILS')node.open=true;}
 });
 document.addEventListener('toggle',event=>{
  const disclosure=event.target;
  if(!disclosure.open||!disclosure.matches?.('.av-premium-contents,.av-premium-policy,.av-premium-disclosure'))return;
  window.AvonticAnalytics?.track?.('av_ipad_purchase_detail_open',{detail:disclosure.querySelector('summary')?.textContent.trim(),path:location.pathname});
 },true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avontic-setup-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('avontic-setup-upsell')) {
    class AvonticSetupUpsell extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.config = this.readConfig();
        this.linkElement = this.querySelector('[data-av-setup-link]');
        this.titleLinkElement = this.querySelector('[data-av-setup-title-link]');
        this.imageElement = this.querySelector('[data-av-setup-image]');
        this.placeholderElement = this.querySelector('[data-av-setup-placeholder]');
        this.titleElement = this.querySelector('[data-av-setup-title]');
        this.variantElement = this.querySelector('[data-av-setup-variant]');
        this.benefitElement = this.querySelector('[data-av-setup-benefit]');
        this.priceElement = this.querySelector('[data-av-setup-price]');
        this.compareElement = this.querySelector('[data-av-setup-compare]');
        this.matchedModelElement = this.querySelector('[data-av-setup-matched-model]');
        this.matchLabelElement = this.querySelector('[data-av-setup-match-label]');
        this.buttonElement = this.querySelector('[data-av-setup-add]');
        this.buttonLabelElement = this.querySelector('[data-av-setup-button-label]');
        this.viewElement = this.querySelector('[data-av-setup-view]');
        this.messageElement = this.querySelector('[data-av-setup-message]');
        this.matchStatusElement = this.querySelector('[data-av-setup-match-status]');
        this.config.mainVariants ||= {};
        if (this.config.selectedMainVariant?.id) {
          this.config.mainVariants[String(this.config.selectedMainVariant.id)] = this.config.selectedMainVariant;
        }
        this.cartVariantIds = new Set();
        this.cartHydrated = Boolean(this.config.allowDuplicates);
        this.cartHydrationFailed = false;
        this.currentMainVariant = null;
        this.currentMatch = { status: 'review', variant: null, method: 'initial' };
        this.loading = false;
        this.requestSequence = 0;
        this.buttonElement?.addEventListener('click', () => this.handleButtonClick(), { signal: this.abortController.signal });
        this.bindEvents();
        const requestedVariantId = new URL(window.location.href).searchParams.get('variant');
        this.updateVariant(requestedVariantId || this.config.selectedMainVariant?.id);
        this.hydrateCart();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        window.clearTimeout(this.addedTimer);
        this.requestSequence += 1;
      }

      readConfig() {
        const element = this.querySelector('[data-av-setup-config]');
        if (!element) return { mainVariants: {}, setupVariants: [], translations: {} };
        try {
          return JSON.parse(element.textContent);
        } catch (error) {
          return { mainVariants: {}, setupVariants: [], translations: {} };
        }
      }

      bindEvents() {
        this.productForm = document.forms[this.dataset.productFormId];
        this.handleFormChange = (event) => {
          if (event.target?.name !== 'id') return;
          queueMicrotask(() => {
            if (!this.variantMatchesRequestedUrl(event.target.value)) {
              this.renderVariantPending();
              return;
            }
            this.updateVariant(event.target.value);
          });
        };
        this.handleVariantChange = (event) => {
          if (event.detail?.formId && event.detail.formId !== this.dataset.productFormId) return;
          const variant = event.detail?.variant;
          if (!this.variantMatchesRequestedUrl(variant?.id)) {
            this.renderVariantPending();
            return;
          }
          this.updateVariant(variant?.id, variant);
        };
        this.handleProductRerender = (event) => {
          const fragment = event.detail?.htmlFragment;
          if (!fragment?.querySelector) return;
          const escapedBlockId = window.CSS?.escape ? window.CSS.escape(this.dataset.blockId) : this.dataset.blockId;
          const blockSelector = '[data-block-id="' + escapedBlockId + '"] [data-av-setup-config]';
          const configElement = fragment.querySelector(blockSelector) || fragment.querySelector('[data-av-setup-config]');
          if (!configElement) return;
          try {
            const remoteConfig = JSON.parse(configElement.textContent);
            this.config.mainOptionFound = remoteConfig.mainOptionFound;
            this.config.mainOptionIndex = remoteConfig.mainOptionIndex;
            this.config.mainOptionDetection = remoteConfig.mainOptionDetection;
            if (remoteConfig.selectedMainVariant?.id) {
              this.config.mainVariants[String(remoteConfig.selectedMainVariant.id)] = remoteConfig.selectedMainVariant;
            }
          } catch (error) {
            return;
          }
        };
        this.handlePopState = () => {
          const variantId = new URL(window.location.href).searchParams.get('variant');
          this.updateVariant(variantId || this.productForm?.elements?.id?.value);
        };
        this.handleCartChange = (event) => {
          const items = event.detail?.cart?.items;
          if (!Array.isArray(items)) return;
          this.cartVariantIds = new Set(items.map((item) => String(item.variant_id || item.id)));
          this.cartHydrated = true;
          this.cartHydrationFailed = false;
          this.renderCurrent();
        };
        this.productForm?.addEventListener('change', this.handleFormChange, { signal: this.abortController.signal });
        this.productForm?.addEventListener('product:rerender', this.handleProductRerender, { signal: this.abortController.signal });
        this.productForm?.addEventListener('variant:change', this.handleVariantChange, { signal: this.abortController.signal });
        window.addEventListener('popstate', this.handlePopState, { signal: this.abortController.signal });
        document.addEventListener('cart:change', this.handleCartChange, { signal: this.abortController.signal });
      }

      async updateVariant(variantId, eventVariant = null) {
        const id = this.normalizeVariantId(variantId);
        if (!id) {
          this.requestSequence += 1;
          this.currentMainVariant = null;
          this.currentMatch = this.findSetupMatch(null);
          this.renderCurrent();
          return;
        }
        if (this.currentMainVariant?.id === id && !this.loading) return;
        const requestId = ++this.requestSequence;
        let mainVariant = this.config.mainVariants?.[id] || null;
        if (!mainVariant && !eventVariant) {
          mainVariant = await this.fetchSelectedMainVariant(id);
        }
        if (requestId !== this.requestSequence) return;
        if (!mainVariant && eventVariant) {
          mainVariant = this.mainVariantFromEvent(eventVariant);
        }
        this.currentMainVariant = mainVariant;
        this.currentMatch = this.findSetupMatch(mainVariant);
        this.renderCurrent();
      }

      mainVariantFromEvent(variant) {
        const model = this.config.mainOptionFound ? variant.options?.[this.config.mainOptionIndex] : variant.title;
        return {
          id: String(variant.id || ''),
          available: Boolean(variant.available),
          model: model || variant.title || '',
          modelKey: null,
          directSetup: null
        };
      }

      async fetchSelectedMainVariant(variantId) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { headers: { Accept: 'text/html' } });
          if (!response.ok) return null;
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const escapedBlockId = window.CSS?.escape ? window.CSS.escape(this.dataset.blockId) : this.dataset.blockId;
          const blockSelector = '[data-block-id="' + escapedBlockId + '"] [data-av-setup-config]';
          const configElement = parsed.querySelector(blockSelector) || parsed.querySelector('[data-av-setup-config]');
          if (!configElement) return null;
          const remoteConfig = JSON.parse(configElement.textContent);
          const requestedId = this.normalizeVariantId(variantId);
          const selectedId = this.normalizeVariantId(remoteConfig.selectedMainVariant?.id);
          if (!requestedId || selectedId !== requestedId) return null;
          this.config.mainVariants[selectedId] = remoteConfig.selectedMainVariant;
          return remoteConfig.selectedMainVariant;
        } catch (error) {
          return null;
        }
      }

      findSetupMatch(mainVariant) {
        if (!mainVariant) return { status: 'review', variant: null, method: 'main_variant_missing' };
        if (mainVariant.directSetup) {
          return { status: 'exact', variant: mainVariant.directSetup, method: 'direct_setup_variant' };
        }
        if (this.config.accessoryVariantMapLimited) {
          return { status: 'review', variant: null, method: 'accessory_catalog_limited' };
        }

        const setupVariants = Array.isArray(this.config.setupVariants) ? this.config.setupVariants : [];
        const candidateKeys = new Set([mainVariant.modelKey, mainVariant.model].map((value) => this.normalizeModelKey(value)).filter(Boolean));
        if (candidateKeys.size) {
          const keyMatches = setupVariants.filter((variant) => variant.modelKey && candidateKeys.has(this.normalizeModelKey(variant.modelKey)));
          if (keyMatches.length === 1) {
            return { status: 'exact', variant: keyMatches[0], method: 'model_key' };
          }
          if (keyMatches.length > 1) {
            return { status: 'review', variant: null, method: 'ambiguous_model_key' };
          }
        }

        if (!this.config.mainOptionFound || !this.config.setupOptionFound) {
          return { status: 'review', variant: null, method: 'compatibility_option_ambiguous' };
        }
        const trustedDetections = new Set(['metafield_override', 'option_keyword']);
        if (!trustedDetections.has(this.config.mainOptionDetection) || !trustedDetections.has(this.config.setupOptionDetection)) {
          return { status: 'review', variant: null, method: 'heuristic_option_detection' };
        }
        const targetModel = this.normalizeKey(mainVariant.model);
        if (!targetModel) return { status: 'review', variant: null, method: 'compatibility_value_missing' };
        const optionMatches = setupVariants.filter((variant) => this.normalizeKey(variant.model) === targetModel);
        if (optionMatches.length === 1) {
          return { status: 'exact', variant: optionMatches[0], method: 'normalized_option_value' };
        }
        if (optionMatches.length > 1) {
          return { status: 'review', variant: null, method: 'ambiguous_option_value' };
        }
        return { status: 'review', variant: null, method: 'no_exact_match' };
      }

      normalizeKey(value) {
        return String(value || '')
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[\u2018\u2019]/g, "'")
          .toLowerCase()
          .replace(/&/g, ' and ')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim()
          .replace(/\s+/g, ' ');
      }

      normalizeVariantId(value) {
        const id = String(value || '').trim();
        return /^\d+$/.test(id) ? id : '';
      }

      variantMatchesRequestedUrl(variantId) {
        const requestedValue = new URL(window.location.href).searchParams.get('variant');
        if (requestedValue === null) return true;
        const requestedId = this.normalizeVariantId(requestedValue);
        const selectedId = this.normalizeVariantId(variantId);
        return Boolean(requestedId && selectedId && requestedId === selectedId);
      }

      renderVariantPending() {
        this.requestSequence += 1;
        this.currentMainVariant = null;
        this.currentMatch = this.findSetupMatch(null);
        this.renderCurrent();
      }

      normalizeModelKey(value) {
        return this.normalizeKey(value).replace(/\s+/g, '');
      }

      renderCurrent() {
        const linkedProduct = this.config.linkedProduct || {};
        const mainVariant = this.currentMainVariant;
        const exactMatch = this.currentMatch?.status === 'exact' && this.currentMatch.variant;
        const setupData = exactMatch ? this.currentMatch.variant : linkedProduct;
        const translations = this.config.translations || {};
        const mainModel = mainVariant?.model || '';
        const matchedTemplate = exactMatch ? translations.matchedTo : translations.reviewFor;

        this.hidden = false;
        this.dataset.state = exactMatch ? 'ready' : 'review';
        this.matchLabelElement.textContent = exactMatch ? translations.matched : translations.review;
        this.matchedModelElement.textContent = String(matchedTemplate || '').replace('__MODEL__', mainModel);
        this.titleElement.textContent = setupData.productTitle || linkedProduct.productTitle || '';
        const variantTitle = exactMatch ? setupData.variantTitle || '' : '';
        this.variantElement.textContent = variantTitle;
        this.variantElement.hidden = !variantTitle || variantTitle.toLowerCase() === 'default title';
        this.benefitElement.textContent = setupData.benefit || linkedProduct.benefit || translations.fallbackBenefit || '';
        const displayPrice = setupData.price || linkedProduct.price || '';
        this.priceElement.textContent = exactMatch ? displayPrice : String(translations.fromPrice || '__PRICE__').replace('__PRICE__', displayPrice);
        this.compareElement.textContent = exactMatch ? setupData.compareAtPrice || '' : '';
        this.compareElement.hidden = !exactMatch || !setupData.compareAtPrice;
        this.updateLinks(exactMatch ? setupData.url : linkedProduct.url, linkedProduct.url);
        this.updateImage(setupData);
        const matchAnnouncement = [
          exactMatch ? translations.matched : translations.review,
          String(matchedTemplate || '').replace('__MODEL__', mainModel),
          setupData.productTitle || linkedProduct.productTitle || '',
          this.priceElement.textContent || ''
        ].filter(Boolean).join('. ');
        if (this.matchStatusElement && matchAnnouncement !== this.lastMatchAnnouncement) {
          this.matchStatusElement.textContent = matchAnnouncement;
          this.lastMatchAnnouncement = matchAnnouncement;
        }
        this.buttonElement.hidden = !exactMatch;
        this.viewElement.hidden = Boolean(exactMatch);
        this.viewElement.href = linkedProduct.url || '#';

        if (!exactMatch) {
          this.messageElement.textContent = '';
          return;
        }

        const productTitle = setupData.productTitle || linkedProduct.productTitle || '';
        const addAccessibleLabel = String(translations.addProduct || translations.add || '').replace('__PRODUCT__', productTitle);
        if (!this.cartHydrated) {
          this.setButtonState('checking', translations.add, true, addAccessibleLabel);
          if (this.cartHydrationFailed) this.messageElement.textContent = translations.error || '';
          return;
        }
        if (!mainVariant?.available) {
          this.setButtonState('unavailable', translations.chooseAvailable, true);
          return;
        }
        if (!setupData.available) {
          this.setButtonState('sold-out', translations.soldOut, true);
          return;
        }
        if (!this.config.allowDuplicates && this.cartVariantIds.has(String(setupData.id))) {
          this.setButtonState('in-cart', translations.inCart, false);
          return;
        }
        if (!this.loading) this.setButtonState('ready', translations.add, false, addAccessibleLabel);
      }

      updateLinks(exactUrl, fallbackUrl) {
        const href = exactUrl || fallbackUrl || '#';
        this.linkElement.href = href;
        this.titleLinkElement.href = href;
      }

      updateImage(setupData) {
        if (setupData.image) {
          this.imageElement.src = setupData.image;
          this.imageElement.alt = '';
          this.imageElement.hidden = false;
          this.placeholderElement.hidden = true;
          return;
        }
        this.imageElement.removeAttribute('src');
        this.imageElement.alt = '';
        this.imageElement.hidden = true;
        this.placeholderElement.hidden = false;
      }

      setButtonState(state, label, disabled, accessibleLabel = label) {
        this.dataset.state = state;
        this.buttonLabelElement.textContent = label || '';
        this.buttonElement.disabled = Boolean(disabled);
        this.buttonElement.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
        this.buttonElement.setAttribute('aria-label', accessibleLabel || label || '');
      }

      async hydrateCart() {
        if (this.config.allowDuplicates) {
          this.cartHydrated = true;
          this.cartHydrationFailed = false;
          return;
        }
        let hydrated = false;
        try {
          const response = await fetch(this.route('cart.js'), { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Cart hydration failed');
          const cart = await response.json();
          this.cartVariantIds = new Set((cart.items || []).map((item) => String(item.variant_id)));
          hydrated = true;
        } catch (error) {
          this.cartVariantIds = new Set();
        } finally {
          this.cartHydrated = hydrated;
          this.cartHydrationFailed = !hydrated;
          this.renderCurrent();
        }
      }

      async handleButtonClick() {
        const setupVariant = this.currentMatch?.status === 'exact' ? this.currentMatch.variant : null;
        if (!this.cartHydrated || this.loading || !setupVariant || !this.currentMainVariant?.available || !setupVariant.available) return;
        const translations = this.config.translations || {};
        const alreadyInCart = !this.config.allowDuplicates && this.cartVariantIds.has(String(setupVariant.id));

        if (alreadyInCart) {
          this.messageElement.textContent = String(translations.alreadyMessage || '').replace('__PRODUCT__', setupVariant.productTitle || '');
          this.openCart();
          return;
        }

        const requestedSetupId = String(setupVariant.id);
        const requestedMainId = String(this.currentMainVariant.id);
        this.loading = true;
        this.setButtonState('loading', translations.adding, true);
        this.messageElement.textContent = '';

        let payload;
        try {
          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: { sections }
          }));
          const response = await fetch(this.route('cart/add.js'), {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{ id: Number(setupVariant.id), quantity: 1 }],
              sections: [...new Set(sections)],
              sections_url: window.location.pathname + window.location.search
            })
          });
          payload = await response.json();
          if (!response.ok) throw new Error(payload.description || translations.error);
        } catch (error) {
          this.loading = false;
          this.renderCurrent();
          this.messageElement.textContent = error.message || translations.error || '';
          return;
        }

        this.cartVariantIds.add(requestedSetupId);
        if (window.themeVariables?.settings?.cartType === 'page' || window.themeVariables?.settings?.pageType === 'cart') {
          window.location.href = this.route('cart');
          return;
        }
        let cartContent = null;
        try {
          const cartResponse = await fetch(this.route('cart.js'), { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) {
            cartContent = await cartResponse.json();
            cartContent.sections = payload.sections || {};
          }
        } catch (error) {
          cartContent = null;
        }

        if (cartContent) {
          const eventDetail = {
            items: payload.items || (payload.id ? [payload] : []),
            cart: cartContent,
            onSuccessDo: 'force_open_drawer'
          };
          this.productForm?.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: eventDetail }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              onSuccessDo: 'force_open_drawer',
              cart: cartContent
            }
          }));
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.setTimeout(() => this.openCart(), 180);
        }

        this.loading = false;
        const stillCurrent = String(this.currentMainVariant?.id || '') === requestedMainId && String(this.currentMatch?.variant?.id || '') === requestedSetupId;
        this.messageElement.textContent = String(translations.addedMessage || '').replace('__PRODUCT__', setupVariant.productTitle || '');
        if (!stillCurrent) {
          this.renderCurrent();
          return;
        }
        this.setButtonState('added', translations.added, false);
        window.clearTimeout(this.addedTimer);
        this.addedTimer = window.setTimeout(() => {
          if (String(this.currentMatch?.variant?.id || '') === requestedSetupId) {
            if (this.config.allowDuplicates) {
              const accessibleLabel = String(translations.addProduct || translations.add || '').replace('__PRODUCT__', setupVariant.productTitle || '');
              this.setButtonState('ready', translations.add, false, accessibleLabel);
            } else {
              this.setButtonState('in-cart', translations.inCart, false);
            }
          }
        }, 1700);
      }

      openCart() {
        if (window.themeVariables?.settings?.cartType === 'page' || window.themeVariables?.settings?.pageType === 'cart') {
          window.location.href = this.route('cart');
          return;
        }
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.show === 'function') {
          cartDrawer.show();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }

      route(path) {
        const root = window.Shopify?.routes?.root || '/';
        return root + String(path || '').replace(/^\//, '');
      }
    }

    customElements.define('avontic-setup-upsell', AvonticSetupUpsell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avontic-smartfit-console"] && !Shopify.designMode) return;
  try {
    (() => {
    const VERSION = '2026-07-27.2';
    if (window.AvonticSmartFit?.version === VERSION || !('customElements' in window)) return;

    const readJson = (root, selector) => {
      try {
        return JSON.parse(root.querySelector(selector)?.textContent || '{}');
      } catch (_) {
        return {};
      }
    };

    const track = (name, payload = {}) => {
      try {
        return window.AvonticAnalytics?.track?.(name, payload);
      } catch (_) {
        return false;
      }
    };

    class AvonticSmartFitSummary extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.config = readJson(this, '[data-av-smartfit-config]');
        this.status = this.querySelector('[data-av-smartfit-status]');
        this.statusLabel = this.querySelector('[data-av-smartfit-status-label]');
        this.selectionLabel = this.querySelector('[data-av-smartfit-selection]');
        this.priceLabel = this.querySelector('[data-av-smartfit-price]');
        this.configureButton = this.querySelector('[data-av-smartfit-configure]');
        this.configureLabel = this.querySelector('[data-av-smartfit-configure-label]');
        this.restoreVerification();
        this.bindProductFormEvents();

        this.configureButton?.addEventListener('click', () => this.openConfiguration(), {
          signal: this.controller.signal
        });

        document.addEventListener('avontic:pdp-fit-verification', (event) => {
          if (String(event.detail?.productId || '') !== String(this.config.productId || '')) return;
          this.applyVerification(event.detail);
        }, { signal: this.controller.signal });

        document.addEventListener('change', (event) => {
          if (!this.config.fitRecommended) return;
          const control = event.target instanceof Element
            ? event.target.closest('[data-option-position], select[name="id"]')
            : null;
          const productRoot = this.closest('#avontic-primary-product') || document.querySelector('#avontic-primary-product');
          if (!control || !productRoot?.contains(control)) return;
          this.applyVerification({ verified: false });
        }, { capture: true, signal: this.controller.signal });

        track('av_smartfit_view', {
          component: 'smartfit_console',
          product_id: this.config.productId,
          variant_id: this.config.variantId,
          family: this.config.family,
          fit_recommended: Boolean(this.config.fitRecommended)
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      savedVerification() {
        const mapped = window.AvonticPdpFinderState instanceof Map
          ? window.AvonticPdpFinderState.get(String(this.config.productId || ''))
          : null;
        if (mapped?.modelNumber && mapped?.optionKey) {
          return {
            verified: true,
            modelNumber: String(mapped.modelNumber),
            optionKey: String(mapped.optionKey)
          };
        }
        try {
          const state = JSON.parse(sessionStorage.getItem(`avontic:rg-fit:${this.config.productId}`) || 'null');
          return state?.verified ? state : null;
        } catch (_) {
          return null;
        }
      }

      restoreVerification() {
        if (!this.config.fitRecommended || !this.config.available) return;
        const saved = this.savedVerification();
        if (saved) this.applyVerification(saved);
      }

      bindProductFormEvents() {
        const bind = () => {
          const form = document.getElementById(this.config.formId);
          if (!form || this.productForm === form) return Boolean(form);
          this.productForm = form;
          form.addEventListener('variant:change', (event) => {
            if (event.detail?.formId && event.detail.formId !== this.config.formId) return;
            this.applyVariant(event.detail?.variant);
          }, { signal: this.controller.signal });
          form.addEventListener('product:rerender', (event) => {
            this.applyRerender(event.detail?.htmlFragment);
          }, { signal: this.controller.signal });
          return true;
        };

        if (bind()) return;
        queueMicrotask(bind);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', bind, {
            once: true,
            signal: this.controller.signal
          });
        }
      }

      formatMoney(price) {
        const cents = Number(price);
        if (!Number.isFinite(cents)) return '';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency',
            currency: this.config.currency || 'USD'
          }).format(cents / 100);
        } catch (_) {
          return '';
        }
      }

      applyVariant(variant) {
        if (!variant?.id) return;
        this.config.variantId = String(variant.id);
        this.config.available = Boolean(variant.available);
        if (variant.title && variant.title !== 'Default Title' && this.selectionLabel) {
          this.selectionLabel.textContent = variant.title;
        }
        const formattedPrice = this.formatMoney(variant.price);
        if (formattedPrice && this.priceLabel) this.priceLabel.textContent = formattedPrice;
        this.applyVerification({ verified: false });
        window.AvonticSmartFit?.hydrate?.();
      }

      applyRerender(fragment) {
        if (!fragment?.querySelectorAll) return;
        const remote = Array.from(fragment.querySelectorAll('avontic-smartfit-summary'))
          .find((summary) => String(summary.dataset.productId || '') === String(this.config.productId || ''));
        if (!remote) return;

        const remoteConfig = readJson(remote, '[data-av-smartfit-config]');
        const remoteSelection = remote.querySelector('[data-av-smartfit-selection]');
        const remotePrice = remote.querySelector('[data-av-smartfit-price]');
        const remoteStatus = remote.querySelector('[data-av-smartfit-status-label]');
        Object.assign(this.config, remoteConfig);
        if (remoteSelection && this.selectionLabel) this.selectionLabel.textContent = remoteSelection.textContent.trim();
        if (remotePrice && this.priceLabel) this.priceLabel.textContent = remotePrice.textContent.trim();
        if (remoteStatus && this.statusLabel) this.statusLabel.textContent = remoteStatus.textContent.trim();
        this.dataset.state = remote.dataset.state || this.dataset.state;
        if (this.status) this.status.dataset.state = this.dataset.state;
        if (this.configureButton) {
          this.configureButton.hidden = !remote.querySelector('[data-av-smartfit-configure]');
        }
        window.AvonticSmartFit?.hydrate?.();
      }

      applyVerification(detail = {}) {
        if (!this.config.fitRecommended || !this.config.available) return;
        const verified = Boolean(detail.verified);
        const label = verified ? this.config.verifiedLabel : this.config.confirmLabel;
        this.dataset.state = verified ? 'verified' : 'verification-required';
        if (this.status) this.status.dataset.state = verified ? 'verified' : 'verification-required';
        if (this.statusLabel) {
          this.statusLabel.textContent = verified && detail.modelNumber
            ? `${label} · ${detail.modelNumber}`
            : label;
        }
        if (this.configureLabel) {
          this.configureLabel.textContent = verified
            ? this.config.verifiedLabel
            : this.config.confirmLabel;
        }
        document.querySelectorAll(`.av-pdp-sticky-cockpit[data-product-id="${CSS.escape(String(this.config.productId || ''))}"] .av-pdp-sticky__state`).forEach((element) => {
          element.dataset.state = verified ? 'verified' : 'verification-required';
          element.textContent = verified && detail.modelNumber
            ? `${label} · ${detail.modelNumber}`
            : label;
        });
      }

      openConfiguration() {
        const productRoot = this.closest('#avontic-primary-product') || document.querySelector('#avontic-primary-product');
        const finder = productRoot?.querySelector('avontic-pdp-model-finder');
        const details = finder?.querySelector(':scope > details');
        const target = finder || productRoot?.querySelector('variant-picker') || this;
        if (details) details.open = true;
        target?.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
        window.setTimeout(() => {
          const focusTarget = finder?.querySelector('[data-av-pdp-model-input]')
            || productRoot?.querySelector('input[data-option-position], button[aria-controls*="variant"]');
          focusTarget?.focus({ preventScroll: true });
        }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 280);
        track('av_smartfit_configure', {
          component: 'smartfit_console',
          product_id: this.config.productId,
          variant_id: this.config.variantId,
          destination: finder ? 'model_finder' : 'variant_picker'
        });
      }
    }

    if (!customElements.get('avontic-smartfit-summary')) {
      customElements.define('avontic-smartfit-summary', AvonticSmartFitSummary);
    }

    const syncSticky = () => {
      const root = document.querySelector('#avontic-primary-product');
      const summary = root?.querySelector('avontic-smartfit-summary');
      const sticky = document.querySelector('.av-pdp-sticky-cockpit');
      if (!summary || !sticky) return;
      const config = readJson(summary, '[data-av-smartfit-config]');
      const mainButton = root.querySelector('[data-block-type="buy-buttons"] button[type="submit"]');
      const stickyButton = sticky.querySelector('.buy-buttons > .button');
      const validPurchase = Boolean(mainButton && !mainButton.disabled && mainButton.getAttribute('aria-disabled') !== 'true');
      const previousReadyState = sticky.dataset.avSmartfitReady;
      if (stickyButton) {
        stickyButton.toggleAttribute('disabled', !validPurchase);
        stickyButton.setAttribute('aria-disabled', validPurchase ? 'false' : 'true');
      }
      sticky.dataset.avSmartfitReady = validPurchase ? 'true' : 'false';
      sticky.dataset.avSmartfitVersion = VERSION;

      if (sticky.dataset.avSmartfitBound !== VERSION) {
        sticky.dataset.avSmartfitBound = VERSION;
        sticky.addEventListener('click', (event) => {
          const button = event.target instanceof Element ? event.target.closest('.buy-buttons > .button') : null;
          if (!button || !button.disabled) return;
          event.preventDefault();
          summary.openConfiguration();
        });
      }

      const verified = summary.dataset.state === 'verified';
      const stickyState = sticky.querySelector('.av-pdp-sticky__state');
      if (stickyState && verified) stickyState.dataset.state = 'verified';
      if (previousReadyState !== sticky.dataset.avSmartfitReady) {
        track('av_smartfit_sticky_ready', {
          component: 'smartfit_sticky',
          product_id: config.productId,
          variant_id: config.variantId,
          result: validPurchase ? 'ready' : 'unavailable'
        });
      }
    };

    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        syncSticky();
      });
    };

    const start = () => {
      syncSticky();
      const root = document.querySelector('#avontic-primary-product')?.parentElement || document.body;
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
      document.addEventListener('avontic:pdp-fit-verification', schedule);
      document.addEventListener('change', schedule, true);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.AvonticSmartFit = Object.freeze({ version: VERSION, hydrate: schedule });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["avontic-studio-product-link"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('avontic-studio-link')){customElements.define('avontic-studio-link',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',event=>{const link=event.target.closest('a');if(!link)return;const form=document.getElementById(this.dataset.form);const id=form?.querySelector('[name="id"]')?.value;if(id&&/^\d+$/.test(id)){const url=new URL(link.href);url.searchParams.set('variant',id);link.href=url.href;}});}});}
  } catch(e) { console.error(e); }
})();

})();
